import { render, staticRenderFns } from "./RecentDownloads.vue?vue&type=template&id=48efbb97"
import script from "./RecentDownloads.vue?vue&type=script&lang=js"
export * from "./RecentDownloads.vue?vue&type=script&lang=js"
import style0 from "./RecentDownloads.vue?vue&type=style&index=0&id=48efbb97&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports